/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      // App is being served from cache by a service worker
    },
    registered () {
    },
    cached () {
    },
    updatefound () {
    },
    updated () {
      window.location.reload()
    },
    offline () {
    },
    error () {
    }
  })
}
